import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { PRODUCTS, PRODUCT_SLUGS, scrollToId, trackEvent } from "@/lib/vgt";
import { Reveal, SectionHeader } from "./Reveal";

export const Products = () => {
  const pick = (formValue) => {
    window.dispatchEvent(new CustomEvent("vgt:select-product", { detail: formValue }));
    trackEvent("select_product", { vanilla_type: formValue });
    scrollToId("quotation");
  };

  return (
    <section id="products" data-testid="products-section" className="py-20 sm:py-28 px-4 sm:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          eyebrow="01 · Our Vanilla Products"
          title="Four Export Lines, One Origin"
          sub="Wholesale vanilla beans and powder, cured and sorted in Indonesia. Specifications are shared per batch before you commit."
        />
        <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-6">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <article
                data-testid={`product-card-${p.id}`}
                className="group h-full bg-white border border-[#E6DEC3] rounded-3xl overflow-hidden flex flex-col transition-shadow duration-500 hover:shadow-2xl"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={p.image}
                    alt={`${p.name} — Indonesian vanilla`}
                    loading="lazy"
                    className={`w-full aspect-[4/3] object-cover transition-transform duration-700 group-hover:scale-105 ${p.imageClass || ""}`}
                  />
                  <span className="absolute top-4 left-4 bg-[#1C120C]/80 backdrop-blur text-[#FAF6EE] font-mono text-[10px] tracking-[0.2em] uppercase rounded-full px-3 py-1.5">
                    {p.tag}
                  </span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-serif font-bold text-xl text-[#2C1A0C]">{p.name}</h3>
                  <dl className="mt-4 space-y-2 flex-1">
                    {p.specs.map(([k, v]) => (
                      <div key={k} className="flex justify-between gap-3 text-sm border-b border-[#F5EFE6] pb-2">
                        <dt className="font-mono text-[11px] tracking-wider uppercase text-[#6E5B4F] pt-0.5">{k}</dt>
                        <dd className="text-right font-semibold text-[#2C1A0C]">{v}</dd>
                      </div>
                    ))}
                  </dl>
                  <p className="mt-4 text-xs text-[#6E5B4F] leading-relaxed">
                    <span className="font-mono tracking-wider uppercase text-[#5C3A21]">Best for: </span>
                    {p.bestFor}
                  </p>
                  <div className="mt-5 flex items-center justify-between gap-3">
                    <button
                      data-testid={`product-quote-button-${p.id}`}
                      onClick={() => pick(p.formValue)}
                      className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#2E4F3E] hover:text-[#1B3B2B] transition-colors"
                    >
                      Request quote for this product
                      <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </button>
                    <Link
                      data-testid={`product-details-link-${p.id}`}
                      to={`/products/${PRODUCT_SLUGS[p.id]}`}
                      className="shrink-0 font-mono text-[11px] tracking-wider uppercase text-[#6E5B4F] hover:text-[#2E4F3E] transition-colors underline underline-offset-4"
                    >
                      Details
                    </Link>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
